import { bindAndHandleMealCategory } from './../../mealCategory';
import { initTimers } from './timers';

(function ($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);

	$doc.ready(function () {

		$.ajaxSetup({headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}});


		$('select')
			.not('.hidden')
			.each(function ()
			{
				var $select = $(this),
					maxOptions = $select.attr('data-max-selections');

				var chosenOptions = {
					allow_single_deselect: true,
					placeholder_text_multiple: ''
				};

				if (maxOptions) chosenOptions.max_selected_options = maxOptions;

				$select.chosen(chosenOptions);
		});
		bindLinkedItems();
		bindShoppingListControls();

		bindAndHandleMealCategory('#meal-category');

        // Fullscreen image
		$('.fullscreen-img').each(function () {
			$(this).parent().addClass('fullscreen-bg').css('background-image', 'url(' + $(this).attr("src") + ')');
		});

		// Form Contact validation
		if ($('#field-name').length && $('#field-subject').length && $('#field-message').length && $('#field-email').length) {
			var field_name = new LiveValidation('field-name');
			field_name.add(Validate.Presence);

			var field_subject = new LiveValidation('field-subject');
			field_subject.add(Validate.Presence);

			var field_message = new LiveValidation('field-message');
			field_message.add(Validate.Presence);

			var field_email = new LiveValidation('field-email');
			field_email.add(Validate.Email);
		}

		// Custom selectbox

		// File trigger
		$('.file-trigger').on('click', function (e) {
			$(this).closest('.file').find('#field-picture').trigger('click');

			e.preventDefault();
		});

		// Trigger Change Password
		$('.trigger-expand').on('click', function (e) {
			var target = $(this).attr('data-target');

			$(this).addClass('hidden');

			$(target).addClass('expanded');

			e.preventDefault();
		});

		// Popup
		$(".popup-open").fancybox({
			maxWidth: 800,
			maxHeight: 600,
			fitToView: false,
			width: '80%',
			height: '80%',
			autoSize: false,
			closeClick: false,
			helpers: {
				overlay: {
					locked: false
				}
			}
		});

		// Tooltip
		$('[data-toggle="tooltip"]').tooltip();

		// Popover
		$('[data-toggle="popover"]').popover();

		initTimers($('.timer_point'));

		// Takes a 1-digit number and inserts a zero before it
		function padNumber(number)
		{
			var ret = new String(number);
			if (ret.length === 1) ret = "0" + ret;
			return ret;
		}

		function onSelectEventFunc(dateString, cssClass, cssClassHide)
		{
			$('.' + cssClassHide).hide();
			$('.' + cssClass + '_' + dateString).show();
		}

		function formateDate(date, sep)
		{
			var year = date.getFullYear();
			var month = padNumber(date.getMonth() + 1);
			var day = padNumber(date.getDate());

			return ( month + sep + day + sep + year );
		}

		function bindLinkedItems(){
			$('.linked[data-link]').on('click', function(e){
                if(!$(e.target).hasClass('video_opener')) {
                    e.preventDefault();
                    if ($(this).data('link') !== '') {
                        window.location.href = $(this).data('link');
                    }
				}
			});
		}

		function bindShoppingListControls(){
			var $input = $('#multiplier', '.shopping-list'),
				$plus = $('.btn_plus', '.shopping-list'),
				$minus = $('.btn_minus', '.shopping-list'),
				$quantities = $('.quantity');

			$plus.on('click', function(){
				$minus.removeClass('disabled');
				if (parseInt($input.val()) < 10){
                    $plus.removeClass('disabled');
                    $input.val(parseInt($input.val()) + 1);
                    if (parseInt($input.val()) === 10) { $plus.addClass('disabled'); }
                    refreshQuantities($input.val());
				}
				return false;
			});

            $minus.on('click', function(){
                $plus.removeClass('disabled');
                if (parseInt($input.val()) > 1){
                    $minus.removeClass('disabled');
                    $input.val(parseInt($input.val()) - 1);
                    if (parseInt($input.val()) === 1) { $minus.addClass('disabled'); }
                    refreshQuantities($input.val());
				}
                return false;
            });
		}

		function refreshQuantities($value){
            $('.quantity', '.shopping-list-body').each(function(){
            	$(this).text( parseInt($(this).data('value')) * parseInt($value) );
			})
		}

// Calendar
		var dates = [],
			$dp = $('#datepicker-primary'),
			elements = document.getElementsByClassName("dateField"),
			progess_navlink = $('.progress_nav .nav_link');

		for (var j = 0; j < elements.length; j++) {
			var date = elements[j].value;
			if (jQuery.inArray(date, dates) < 0)
				dates.push(date);
		}

		const langCode = document.documentElement.getAttribute('lang').substring(0, 2);

		var ct = 0;
		$dp.datepicker({
			language: langCode,
			todayHighlight: true,
			beforeShowDay: function (date) {

				var dateString = formateDate(date, "/"),
					gotDate = jQuery.inArray(dateString, dates),
					className = '',
					en = false;

				if (gotDate >= 0) {
					if (ct === dates.length - 1) {
						var dateDash = formateDate(date, "-");
						onSelectEventFunc(dateDash, "date",'progress-day1');
						className = 'active';
					}
					ct++;
					en = true
				}
				return {
					enabled: en,
					classes: className
				};
			}
		}).on('changeDate', function (ev) {
			onSelectEventFunc(formateDate(ev.date, "-"), "date",'progress-day1');
		});

        progess_navlink.on('click', function(e){
			var in_dates = dates.indexOf($(this).data('current'));

			if ($(this).hasClass('go_prev')) {
				if (in_dates < dates.length - 1){
                    $dp.datepicker("setDate", new Date(dates[in_dates + 1]));
				}
            }
            if ($(this).hasClass('go_next')) {
                if (in_dates > 0){
                    $dp.datepicker("setDate", new Date(dates[in_dates - 1]));
                }
            }
		});

        if (dates.length){
            $dp.datepicker("setDate", new Date(dates[0]));
		}

		// Calendar2
		var dates2 = [], elements2 = document.getElementsByClassName("dateField2");

		for (var i = 0; i < elements2.length; i++) {
			var date2 = elements2[i].value;

			if (jQuery.inArray(date2, dates2) < 0)
				dates2.push(date2);
		}
		ct = 0;
		$('#datepicker-primary2').datepicker({
			language: langCode,
			todayHighlight: true,
			beforeShowDay: function (date) {

				var dateString = formateDate(date, "/")

				var gotDate = jQuery.inArray(dateString, dates2);
				var className = '';
				var en = false;
				if (gotDate >= 0) {
					if (ct === 0) {
						var dateDash = formateDate(date, "-")
						onSelectEventFunc(dateDash, "date2",'progress-day2');
						className = 'active';
					}
					ct++;
					en = true
				}
				return {
					enabled: en,
					classes: className
				};
			}
		}).on('changeDate', function (ev) {
			var dateString = formateDate(ev.date, "-");
			onSelectEventFunc(dateString, "date2",'progress-day2');
		});

        $('.print-save-btn').on('click', function(e){
            e.preventDefault();
            $('#btn-action').val(this.id);
            $( "#printSaveFrm" ).submit();
        });

        $('#print-me').on('click',function(){
            window.print();
        });

		$('#datepicker, #dob').datepicker({
			language: langCode,
			format: 'yyyy-mm-dd',
			autoclose: true
		});

		// Mobile navigation button
		$('.nav-btn').on('click', function (e) {
            e.preventDefault();
			$(this).toggleClass('active');
			$('.wrapper-inner, .header-inner').toggleClass('expanded');
		});

		/***************************************************************/
		// shopping list days selection
		$('#selected-day').on('change', function (e) {
			updateShoppingList();
		});

		// change region field according to selected country
		$('#field-country').on('change', function (e) {
			var cid = $(this).val();
			updatePhoneNumberField(cid);
			updateRegionField(cid);
			updatePostcodeField(cid);
		});

		getPhoneCodes();
		getRegions();

		updateRegionField($('#field-country').val());
		updatePostcodeField($('#field-country').val());

		$('[data-validate="true"]').on('change', function(e) {
			try {
				var valid = validateField($(this));
				if (valid['valid']) { validationSuccess($(this)) }
				else { validationFail($(this), valid['message']) }
			} catch (err) {	}
		});

		/***************************************************************/

        var alert_links = $('[data-toggle=alert]'),
            alert_closers = $('.close_link', '.alert'),
            alerts = $('.alert.fade'), backdrop = $('.alert_backdrop');

        backdrop.hide();

        alert_links.on('click', function(e){
            e.preventDefault();
            alerts.hide();
            $($(this).data('target')).show();
            backdrop.show();
        });

        alert_closers.on('click', function(e){
            e.preventDefault();
            $(this).parents('.alert').hide();
            backdrop.hide();
        });

        backdrop.on('click', function(){
            backdrop.hide();
            alerts.hide();
        });

		$(document).on('click', '[data-meal-swap]', (e) => {
			requestMealSubstitute(e.currentTarget);
		})
	});

/**************Print Styles ******************/
$doc.ready(function () {
	$('.link-print[data-type="workout"]').on('click', function (e) {
		
		var $link = $(this).closest('.link-print[data-type="workout"]'),
			weekId = $link.attr('data-week'),
			dayId = $link.attr('data-day'),
			workoutId = $link.attr('data-workout');
		//console.log(weekId, dayId, workoutId);
		$(".cust-style-tag").remove();
		$('<style class="cust-style-tag">@media print {' +
				" .panel-default { display:none; } " +
				" .panel-default[data-week='"+weekId+"'] {display:block;} " +
				" .panel-collapse[data-week='"+weekId+"'] {display:block; height:auto;} " +
				" .panel-body[data-week='"+weekId+"'] {margin-left: 50px;} " +
				" .panel-default[data-day='"+dayId+"'] {display:block;} " +
				" .panel-collapse[data-day='"+dayId+"'] {display:block; height:auto;} " +
				" .panel-body[data-day='"+dayId+"'] {margin-left: 50px;} " +
				" .panel-default[data-workout='"+workoutId+"'] {display:block;} " +
				" .panel-collapse[data-workout='"+workoutId+"'] {display:block; height:auto;} " +
				" .panel-body[data-workout='"+workoutId+"'] {margin-left: 50px;} " +
			'} </style>').appendTo('head');
		//console.log(panelID);
		window.print();

		e.preventDefault();
	});


	$('.link-print-all').on('click', function (e) {
		$(".cust-style-tag").remove();
		$('<style class="cust-style-tag">@media print { .panel-default { display:block; } ' +
			'.panel-default .collapse { display: block;  } }</style>').appendTo('head');
		window.print();

		e.preventDefault();
	});

});

})(jQuery, window, document);

	function updateShoppingList () {
		var selected_day = $('#selected-day').val(), $container = $('#ingredients-body');
		$.ajax({
			'url': $container.attr('data-url'),
			'type': 'POST',
			'data': {'days': selected_day},
			'success': function (data) {
				$container.html(data.html);
			}
		});
	}

	var phone_codes = [];
	
	function getPhoneCodes () {
		var $phone_code_source = $('#phone_codes');
		if ($phone_code_source.length > 0) {
			phone_codes = $.parseJSON($phone_code_source.val());
		}
	}
	
	function updatePhoneNumberField (country) {
		var $phoneNumberField = $("#phone-number"),
			$phoneCodeField = $("#phone-code");
	
		$.each(phone_codes, function (index,value) {
			if (country == index) {
				$phoneNumberField.val(value).focus();
				$phoneCodeField.val(value);
				return false;
			}
		});
	}

	var regions = [], selected_region, selected_customer_region;

	function getRegions () {
		var $regions_source = $('#regions');
		if ($regions_source.length > 0) {
			regions = $.parseJSON($regions_source.val());
			selected_customer_region = $('#selected_region').val();
		}
	}

	function updateRegionField (country) {
		var regionsArr = [],
			do_not_append = false,
			$text_field = $('#field-text-region'),
			$select_field = $('#field-select-region'),
			$row = $text_field.closest('.form-row');

		$.each(regions, function (index,value) {
			if (country == index) {
				$.each(value, function (ind, val)  {
					var arr = [];
					arr.push(val.id);
					arr.push(val.name);
					regionsArr.push(arr);
				})
			}
		});

		if (regionsArr.length == 0) {
			$text_field.removeClass('hidden');
			$text_field.prop('disabled', false);

			$select_field.chosen();
			$select_field.chosen('destroy');
			$select_field.addClass('hidden');
			$select_field.prop('disabled', true);
			$row.removeClass('required');

		} else {
			$text_field.addClass('hidden');
			$text_field.prop('disabled', true);

			$select_field.removeClass('hidden');
			$select_field.prop('disabled', false);

			var selected_region = $select_field.val();

			$.each(regionsArr, function(i,v) {
				if (selected_region == v[0]) {
					do_not_append = true;
				}
			});

			if (!do_not_append) {
				$('#field-select-region').empty();
				$.each(regionsArr, function(i,v) {
					var $append;

					if (v[0] == selected_customer_region) {
						$append = $("<option>").attr("value", v[0]).attr("selected", "selected").text(v[1]);
					} else {
						$append = $("<option>").attr("value", v[0]).text(v[1]);
					}

					$('#field-select-region').append($append);
				});
			} else {
				do_not_append = false;
			}

			//$('#field-select-region').selectmenu('refresh');
			//$('#field-select-region').selectpicker('refresh');
			//$('#field-select-region').selectpicker('show');
			$select_field.chosen();
			$select_field.trigger("chosen:updated");
			
			$row.addClass('required');
		}
	}

	function updatePostcodeField (country) {
		let post_codes = [];
		const $post_code_source = $('#post_codes');

		if ($post_code_source.length > 0) {
			post_codes = $.parseJSON($post_code_source.val());
		}

		var $postcodeRequired = $("#postcode-required"),
			$postcodeField = $("#field-postcode"),
			$row = $postcodeField.closest('.form-row');
		
		$.each(post_codes, function (index,value) {
			if (country == index) {
				if (value === 1) {
					$row.addClass('required');
					$postcodeField.attr('data-validate', 'true');
				} else {
					$row.removeClass('required');
					$postcodeField.attr('data-validate', 'false');
				}
				$postcodeRequired.val(value);
				return false;
			}
		});
	}

	function validationSuccess($field) {
		$field.parent().removeClass('error');
		$field.parent().prev().removeClass('error');
		var fieldName = getFieldName($field).replace(/_|\-/g, ' '), $ul_container = $('.alert-danger:visible').first();
		//console.log('removing: ' + fieldName);
		$ul_container.find($('ul')).find($('li:contains(' + fieldName + ')')).remove();

		if ($('.error').length == 0) $ul_container.remove();
	}

	function validationFail($field, message) {
		$field.parent().addClass('error');
		$field.parent().prev().addClass('error');
		var fieldName = getFieldName($field).replace(/_|\-/g, ' '), $ul_container = $('.alert-danger:visible');

		if ($ul_container.length == 0) {
			$("#main-container").prepend('<div class="alert alert-danger" role="alert"><div class="alert-icon"><i class="ico fa fa-fw fa-2x fa-exclamation-triangle"></i></div><div class="alert-content"><ul><li>' + message + '</li></ul></div></div>');
		} else {
			var $li_container = $ul_container.find($('ul')), $li = $li_container.find($('li:contains(' + fieldName + ')')).first();
			if ($li.length == 0) {
				$li_container.append('<li>' + message + '</li>');
			} else {
				$li.html(message);
			}
		}

		var $error_fields = $('.error');

		if ($error_fields.length > 0) {
			$error_fields.find('[data-validate="true"]').first().focus();
		}
	}

	function updateCollapsibleStates(pid, program_states, element, state) {
		program_states = program_states || {};

		for (let key in program_states) {
			if (!program_states.hasOwnProperty(key)) {
				continue;
			}

			if (!$('#' + key).is(':visible') && key !== 'description') {
				delete program_states[key];
			}
		}

		if (1 === state || element === 'description') {
			program_states[element] = state;
		}


		localStorage.setItem(pid, JSON.stringify(program_states));

		return program_states;
	}


	function requestMealSubstitute (target) {
		var $target = $(target), $clicker = $target.parent().parent().prev(),
			alert_confirm = $('#change_meal_confirmation');

		$('.alert.fade, .alert_backdrop').hide();
		$clicker.hide();

		$.ajax({
			'url': $target.attr('data-url'),
			'type': 'POST',
			'success': function (data)
			{
				if (data.success)
				{
					$clicker.parent().find('.state-text').removeClass('hidden');
					alert_confirm.show();
				}
				else if (data.message)
				{
					$clicker.parent().find('.state-text').removeClass('hidden').text(data.message);
				}
				else
				{
					$target.show();
				}
			},
			'error': function ()
			{
				$target.show();
			}
		});
	}

/***** Additional functions *****/
window.updateCollapsibleStates = updateCollapsibleStates;
